import React, { type FC } from 'react';

import SvgIcon, { Svg } from '../SvgIcon';

interface MessagingCalloutProps {
  coachFirstName: string;
  onMessage: () => void;
}

export const MessagingCallout: FC<MessagingCalloutProps> = ({
  coachFirstName,
  onMessage,
}) => {
  return (
    <div className="flex items-start justify-between space-x-4 rounded-lg border border-leland-gray-stroke p-6">
      <div className="flex flex-col space-y-2 leading-5">
        <p className="text-leland-gray-light">
          <span className="font-medium text-leland-gray-dark">Questions?</span>{' '}
          Start chatting with this coach before you get started.
        </p>
        <button
          type="button"
          className="link link--primary text-start font-medium"
          onClick={onMessage}
        >
          Send {coachFirstName} a message
        </button>
      </div>
      <SvgIcon className="size-8 shrink-0" svgType={Svg.CHAT_ILLUSTRATION} />
    </div>
  );
};
